import { ShareFileTokenReturn } from "../model/ItemModel";
import { ShareFile, ShareFileCreate } from "../model/SharedFileModel";
import { ParameterViwer } from "../pages/WorkSpaceItem/Viwer/ParameterViwer";
import { Api, ApiWithoutToken } from "./api";
import { ReturnParameterViwer } from "./ReturnParameterViwer";
import { SharedItemModel } from "../model/SharedItemModel";
import { PaginationResult } from "../model/PaginationResult";
import { SharedItemRequestModel } from "../model/SharedItemRequestModel";
import { UserMinimal } from "../model/UserModel";

export async function GetSharedFileInformation(idFile: string) {
    const request = await Api.get<ShareFile>(
      "item/shared/" + idFile
    );
  
    return request.data;
}

export async function SaveSharedFileInformation(shareFileCreate: ShareFileCreate) {
  const request = await Api.post<ShareFile[]>(
    "item/shared",
    shareFileCreate
  );

  return request.data;
}

export async function UpdateSharedFileInformation(shareFile: ShareFile) {
  const request = await Api.put<ShareFile[]>(
    "item/shared",
    shareFile
  );

  return request.data;
}

export async function DeleteSharedFileInformation(fileId: string) {
  const request = await Api.delete<ShareFile[]>(
    "item/shared",
    { data: { id: fileId } }   
  );

  return request.data;
}


export async function GetSharedFileInformationByToken(token: string) {
  const request = await ApiWithoutToken.get<ShareFileTokenReturn>(
    "SharedFile/" + token
  );
  return request.data;
}

export async function GetSharedFileUserLogged(reqModel?: SharedItemRequestModel) {
  const request = await Api.get<PaginationResult<SharedItemModel>>("SharedFile/UserLogged", {params: reqModel});
  return request.data;
}

export async function GetUsersSharedFile(nameOrgInternal: string) {
  const request = await Api.get<UserMinimal[]>("SharedFile/UsersWithSharedToUserLogged/" + nameOrgInternal);
  return request.data;
}

export async function GetSharedFileDownloadByToken(token: string,parameter:ParameterViwer, onDownloadProgress?: (progressEvent: any) => void){

  let returnParameter = ReturnParameterViwer(parameter, true);
 
    const request = await ApiWithoutToken.get<any>(
      "SharedFile/" + token + "/download" + returnParameter,
      {
          responseType: 'blob',
          onDownloadProgress:onDownloadProgress
      }
    );
  
  return request.data;
}

export async function UndoItemSharing(itemId: string, emailuser: string, nameOrgInternal: string) {
    const request = await Api.delete(
      "SharedFile/Undo",    
      { data: { itemId: itemId, emailUser: emailuser, nameOrgInternal } }
    );
  }